import React, { useEffect, useState } from "react";

export default function UtcToLocal({ utcTimestamp, options }) {
  const [localTimestamp, setLocalTimestamp] = useState("");

  useEffect(() => {
    if (!utcTimestamp) {
      setLocalTimestamp("");
      return;
    }

    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const nextTimestamp = new Date(Date.parse(utcTimestamp)).toLocaleString(
      "en-US",
      {
        ...options,
        timeZone,
      },
    );

    setLocalTimestamp(nextTimestamp);
  }, [utcTimestamp, options]);

  return <>{localTimestamp !== "Invalid Date" ? localTimestamp : utcTimestamp}</>;
}
